import { ChangeDetectionStrategy, Component, Input, OnChanges, ViewChild, inject } from '@angular/core';
import { ImageSizeEnum } from '../../../../shared/pipes/resize-image/resize-image.pipe';
import { SharedModule } from '../../../../shared/shared.module';
import { LoaderComponent } from '../../../../ui-elements/loader/loader.component';
import { LoaderService } from '../../../../ui-elements/loader/loader.service';
import { TreeService } from '../../tree.service';

export interface CatalogCategoryDataInterface {
  title: string;
  content: string;
  img: string;
}

@Component({
  selector: 'app-navbar-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SharedModule, LoaderComponent],
})
export class DetailsComponent implements OnChanges {
  private treeService = inject(TreeService);
  private loaderService = inject(LoaderService);

  @ViewChild('detailsLoader', { static: true }) detailsLoader: LoaderComponent;

  @Input() elementId: number;
  @Input() fullHeight = false;
  @Input() tag = '';

  data: CatalogCategoryDataInterface;
  imageSizes = ImageSizeEnum;

  ngOnChanges() {
    this.data = null;
    this.loaderService
      .load(this.treeService.getCategoryOrSubCategoryData(this.elementId), this.detailsLoader)
      .subscribe((data: CatalogCategoryDataInterface) => {
        this.data = data;
      });
  }
}
